module.exports = __webpack_public_path__ + "img/undraw_progress_overview_red.38386ab8.svg";